import Head from 'next/head';

import { CaptchaScript } from '@/utils/iframe/captchaHelper';

const HeadScripts = () => (
  <>
    <Head>
      <link rel="preconnect" href="https://mtg.clearvpn.com" />
      <link rel="dns-prefetch" href="https://mtg.clearvpn.com" />
      {/* Google Tag Manager */}
      <script
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://mtg.clearvpn.com/mtgcontainer.js?'+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer');`,
        }}
      />
      {/* End Google Tag Manager */}

      {/* Intercom Support chat: https://developers.intercom.com/installing-intercom/docs/basic-javascript */}
      <script
        dangerouslySetInnerHTML={{
          __html:
            "(function(){var w=window;var ic=w.Intercom;if(typeof ic===\"function\"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/x8m6pqoz';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();",
        }}
      />

      {/* Impact Radius Script */}
      <script
        dangerouslySetInnerHTML={{
          __html:
            "(function(a,b,c,d,e,f,g){e['ire_o']=c;e[c]=e[c]||function(){(e[c].a=e[c].a||[]).push(arguments)};f=d.createElement(b);g=d.getElementsByTagName(b)[0];f.async=1;f.src=a;g.parentNode.insertBefore(f,g);})('https://utt.impactcdn.com/A51414-28a1-4ac5-ad9b-d6dc91f1b1bd1.js','script','ire',document,window);",
        }}
      />
    </Head>
    {/* Google Tag Manager (noscript) */}
    <noscript>
      <iframe
        title="gtm-fallback-iframe"
        src="https://mtg.clearvpn.com/ns.html?id=GTM-NXKF6NBL"
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
      />
    </noscript>
    {/* End Google Tag Manager */}
    <CaptchaScript />
  </>
);

export default HeadScripts;
